export const formatId = (id: string): string => id.replace(/[^\w\s\-]/gi, "");
